import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../styles/styles';
import { BankingDetails } from '../../../../assessment/synopsis/common/banking-details/banking-details';
import { Button, Grid, Typography, withStyles } from '@material-ui/core';
import { LabeledValue } from '../../../../controls/labeled-value';
import { getCodeDescription, GetVerificationWidget } from '../../../../shared-functions';
import { ButtonWrapper } from '../../../../forms';
import { AddPaymentButton } from '../add-payment-item';
import { BeneficiaryDetails, Payment } from '../../../reducer';
import { AddCircle } from '@material-ui/icons';

type Props = StyledComponent & {
    bankingDetails: BankingDetails[];
    riskStatus?: string;
    screeningDate?: Date;
    payments: Payment[];
    paymentIndex: number;
    beneficiary: BeneficiaryDetails;
};
const raPaymentBankingDetailsView: React.FunctionComponent<Props> = ({
    bankingDetails,
    payments,
    paymentIndex,
    beneficiary,
}: Props) => {
    if (bankingDetails[0] === null || bankingDetails.length === 0) {
        return (
            <React.Fragment>
                <>
                    <Grid item xs={12} lg={2}>
                        <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
                            Banking details
                        </Typography>
                    </Grid>
                    <Grid item xs={12} container justify="flex-start">
                        <Grid item xs={4} lg={2}>
                            <LabeledValue label="Account holder name/company name" />
                        </Grid>
                        <Grid item xs={4} lg={2}>
                            <LabeledValue label="Bank Name" />
                        </Grid>
                        <Grid item xs={4} lg={2}>
                            <LabeledValue label="Bank Account Number" />
                        </Grid>
                        <Grid item xs={4} lg={2}>
                            <LabeledValue label="Branch Name" />
                        </Grid>
                        <Grid item xs={4} lg={1}>
                            <LabeledValue label="Branch Code" />
                        </Grid>
                        <Grid
                            item
                            xs={4}
                            lg={2}
                            container
                            justify="flex-start"
                            style={{ marginLeft: '12px' }}
                        >
                            <Grid item xs={12} lg={8}>
                                <LabeledValue label="Account Type" />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <LabeledValue label="Status" />
                            </Grid>
                        </Grid>
                        <Grid item xs={4} lg={2}>
                            <LabeledValue label="Special Instructions" />
                        </Grid>
                        <Grid item xs={12} lg={12} justify="flex-end">
                            <ButtonWrapper>
                                <Button
                                    id="AddPaymentItem"
                                    color="secondary"
                                    style={{ marginLeft: '90%', textTransform: 'none' }}
                                    disabled={true}
                                >
                                    <AddCircle fontSize="small" />
                                    Add Payment
                                </Button>
                            </ButtonWrapper>
                        </Grid>
                    </Grid>
                </>
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            {bankingDetails.map((bankingDetails, index) => {
                return (
                    <>
                        <Grid item xs={12} lg={2}>
                            <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
                                Banking details({index + 1})
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justify="flex-start" key={index}>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Account holder name/company name"
                                    value={`${bankingDetails.accountHoldersInitials || ''} ${
                                        bankingDetails.accountHoldersName || ''
                                    }`}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Bank Name"
                                    value={getCodeDescription('bankName', bankingDetails.bankName)}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Bank Account Number"
                                    value={bankingDetails.accountNumber}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Branch Name"
                                    value={bankingDetails.bankBranch}
                                />
                            </Grid>
                            <Grid item xs={4} lg={1}>
                                <LabeledValue
                                    label="Branch Code"
                                    value={bankingDetails.branchCode}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                lg={2}
                                container
                                justify="flex-start"
                                style={{ marginLeft: '12px' }}
                            >
                                <Grid item xs={12} lg={8}>
                                    <LabeledValue
                                        label="Account Type"
                                        value={bankingDetails.accountType}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <LabeledValue
                                        label="Status"
                                        value={GetVerificationWidget(
                                            bankingDetails.bankAccountStatus || 'Not verified'
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                <LabeledValue
                                    label="Special Instructions"
                                    value={bankingDetails.specialInstructions || 'None'}
                                />
                            </Grid>
                            <Grid item xs={4} lg={2}>
                                {bankingDetails.investmentIdType === 'Reinvestment' ||
                                    (bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                                        <LabeledValue
                                            label="Company Name"
                                            value={`${bankingDetails.companyName || ''}`}
                                        />
                                    ))}
                            </Grid>
                            <Grid item xs={4} lg={4}>
                                {bankingDetails.investmentIdType === 'Reinvestment' ||
                                    (bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                                        <LabeledValue
                                            label="Reference number"
                                            value={bankingDetails.companyReference}
                                        />
                                    ))}
                            </Grid>
                            {!isWTICompleted(beneficiary) && !IsContactDetailsCompleted() && (
                                <ButtonWrapper>
                                    <AddPaymentButton
                                        payments={payments}
                                        paymentIndex={paymentIndex}
                                        bankIndex={index}
                                    />
                                </ButtonWrapper>
                            )}
                        </Grid>
                    </>
                );
            })}
        </React.Fragment>
    );
    function isWTICompleted(bene: BeneficiaryDetails) {
        let wtiStatus = true;
        if (bene.wtiCountry && bene.wtiCountry === 'ZA') {
            wtiStatus = false;
        } else if (bene.wtiCountry && bene.emailAddress && bene.wtiException === 'No') {
            wtiStatus = false;
        } else if (
            bene.wtiCountry &&
            bene.emailAddress &&
            bene.wtiException === 'Yes' &&
            bene.wtiExceptionCode
        ) {
            wtiStatus = false;
        }
        return wtiStatus;
    }

    function IsContactDetailsCompleted() {
        return (
            beneficiary?.contactDetails?.emailAddress === null &&
            beneficiary?.contactDetails?.preferredMethodOfCommunication === null &&
            beneficiary?.contactDetails?.cellphoneNumber === null
        );
    }
};

export const RaPaymentBankingDetailsView = withStyles(styles)(raPaymentBankingDetailsView);
